//@ts-nocheck
import { FieldNoteCreate } from '@packages/database/types';
import api from './client/axios';

export const getFieldNotes = async (): Promise<any> => {
  const response = await api.get('/layers/field-notes');
  return response.data.fieldNotes;
};

export const updateFieldNote = async (note): Promise<any> => {
  const response = await api.patch(
    `/layers/field-notes/${note.id}/update`,
    note,
  );
  return response.data.data;
};

export const createFieldNote = async (
  data: FieldNoteCreate,
  layerId?: string,
): Promise<any> => {
  const response = await api.post('/layers/field-notes', data);
  return response.data;
};

export const deleteFieldNote = async (noteId: string): Promise<void> => {
  await api.delete(`${'/layers/field-notes'}/${noteId}`);
};
